import { motion } from 'framer-motion'
import PlentyHeading from '#app/components/typography/plenty-heading'
import { cn } from '#app/utils/misc'

interface MainCategoryHeaderProps {
	isMainCategory: boolean
	localizedTitle: string
}
export const MainCategoryHeader = ({
	isMainCategory,
	localizedTitle,
}: MainCategoryHeaderProps) => {
	return (
		<motion.div
			className="flex w-full items-center justify-center bg-beige-50"
			animate={{
				height: isMainCategory ? '69px' : 0,
			}}
			initial={{ height: 0 }}
			exit={{ height: 0 }}
			transition={{ duration: 0.3 }}
		>
			<PlentyHeading as="h8" className={cn(isMainCategory ? 'flex' : 'hidden')}>
				{localizedTitle}
			</PlentyHeading>
		</motion.div>
	)
}
